import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export const ScrollToTop = () => {
	const location = useLocation();

	useEffect(() => {
		window.scrollTo({top: 0, behavior: 'instant'});
	}, [location.key]);

	return null;
};
